export default __webpack_public_path__ + "static/media/Profile.fcff9dce.svg";